/**
 * Admin Donations Tab - View donations
 */
import { Heart } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { useAdmin } from "./AdminContext";

const AdminDonationsTab = () => {
  const { donations } = useAdmin();

  const totalDonations = donations.reduce((sum, d) => sum + (d.amount || 0), 0);

  return (
    <Card>
      <CardHeader>
        <CardTitle><Heart className="w-5 h-5 inline mr-2 text-red-500" />Donations</CardTitle>
        <CardDescription>
          Total received: <span className="font-bold text-green-600">£{totalDonations.toFixed(2)}</span>
        </CardDescription>
      </CardHeader>
      <CardContent>
        {donations.length === 0 ? (
          <p className="text-center text-stone-500 py-8">No donations yet</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Donor</TableHead>
                <TableHead>Amount</TableHead>
                <TableHead>Message</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {donations.map(donation => (
                <TableRow key={donation.donation_id}>
                  <TableCell>
                    <p className="font-medium">{donation.donor_name || "Anonymous"}</p>
                    <p className="text-xs text-stone-500">{donation.donor_email || "-"}</p>
                  </TableCell>
                  <TableCell className="font-bold text-green-600">£{donation.amount?.toFixed(2)}</TableCell>
                  <TableCell className="text-sm max-w-xs truncate">{donation.message || "-"}</TableCell>
                  <TableCell>
                    <Badge className={donation.status === "completed" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}>
                      {donation.status || "pending"}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-sm">{new Date(donation.created_at).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default AdminDonationsTab;
